// 弹性离校
export default [
  {
    path: '/flexleave/index',
    name: 'PageFlexLeaveIndex',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/flexleave/PageFlexLeaveIndex'
      ),
    meta: { modular: 8, title: '滞留生托管', info: '滞留生托管——首页' }
  },
  {
    path: '/flexleave/first',
    name: 'PageFlexLeaveFirst',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/flexleave/PageFlexLeaveFirst'
      ),
    meta: {
      modular: 8,
      title: '滞留生托管配置',
      info: '滞留生托管配置——第一步'
    }
  },
  {
    path: '/flexleave/second',
    name: 'PageFlexLeaveSecond',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/flexleave/PageFlexLeaveSecond'
      ),
    meta: {
      modular: 8,
      title: '滞留生托管配置',
      info: '滞留生托管配置——第二步'
    }
  },
  {
    path: '/flexleave/last',
    name: 'PageFlexLeaveLast',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/flexleave/PageFlexLeaveLast'
      ),
    meta: {
      modular: 8,
      title: '滞留生托管配置',
      info: '滞留生托管配置——最后一步'
    }
  },
  {
    path: '/flexleave/setting',
    name: 'PageFlexLeaveSetting',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/flexleave/PageFlexLeaveSetting'
      ),
    meta: { modular: 8, title: '设置', info: '滞留生托管——设置' }
  },
  {
    path: '/flexleave/setting/turns',
    name: 'PageFlexLeaveTurns',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/flexleave/PageFlexLeaveTurns'
      ),
    meta: { modular: 8, title: '值周老师', info: '滞留生托管——值周老师' }
  },
  {
    path: '/flexleave/detention/face',
    name: 'PageFlexLeaveFaceDetention',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/flexleave/PageFaceDetention'
      ),
    meta: { modular: 8, title: '人脸识别', info: '滞留生托管——人脸识别' }
  },
  {
    path: '/flexleave/chooseDeverice',
    name: 'PageLeaveChooseDeverice',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveChooseDeverice'
      ),
    meta: { modular: -1, title: '选择设备', info: '滞留生托管——选择到离校设备' }
  }
]
